import React  from 'react'
import DropDown from '../dropdown';
import {GetUsers} from '../../../api/services/organization'

const UsersDropDown = ({...rest}) => {
    return <DropDown api={GetUsers} textField="UserName" valueField="Id"  {...rest}/> 
}

export default UsersDropDown